'use strict';

var processInclude = require('base/util.js');
$(document).ready(function () {
    processInclude(require('./components/staff_site/staff'));
});